export function getEmployeeTitleRelId(designerType, employeeData) {
    let employeeTitleRelIdValue;
  
    employeeData.forEach(item => {
      if (item.employeeTitleId === designerType) {
        employeeTitleRelIdValue = item.employeeTitleRelId;
      }
    });
  
    return employeeTitleRelIdValue;
  }